
export default {
    props: ['items', 'value'],
    data() {
        return {
            isOpen: false,
        }
    },
    methods: {
        selectValue(value){
            this.$emit('select-value', value);
            this.isOpen = false;
        },
        close(){
            this.isOpen = false;
        },
    }
}
